<template>
  <el-dialog title="学员详情" :visible.sync="dialogVisible" width="98%" class="student-info">
    <el-tabs value="base">
      <el-tab-pane label="基础信息" name="base">
        <ul class="base-inf">
          <li>
            <span>姓名</span>
            <i>{{ baseInfo.name }}</i>
          </li>
          <li>
            <span>出生日期</span>
            <i>{{ baseInfo.birthday }}</i>
          </li>
          <li>
            <span>性别</span>
            <i>{{ baseInfo.gender_label }}</i>
          </li>
          <li>
            <span>身份证号</span>
            <i>{{ baseInfo.id_card_no }}</i>
          </li>
          <li>
            <span>就读年级</span>
            <i>{{ baseInfo.grade_label }}</i>
          </li>
          <li>
            <span>监护人姓名</span>
            <i>{{ baseInfo.real_name }}</i>
          </li>
          <li>
            <span>监护人手机号</span>
            <i>{{ baseInfo.phone }}</i>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="报名信息" name="sign">
        <ly-table
          :getTableData="getTableData"
          :tableHeader="tableHeaderSign"
          :searchFormData="searchFormData"
          ref="lyTable"
        >
          <template v-slot:org_full_name="row">
            {{ row.org_full_name | lastName }}
          </template>
          <template v-slot:specialized="row">
            {{ row.specialized_subject_full_name | lastName }}
          </template>
        </ly-table>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import { Dialog, Tabs, TabPane } from 'element-ui';
import LyTable from '@/components/LyTable';
import { studentSignTable } from '@/utils/tableHeader';
import { contact } from '@/api';

export default {
  name: 'StudentInfo',
  components: {
    ElDialog: Dialog,
    LyTable,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  props: {
    contact_id: {
      required: true
    }
  },
  filters: {
    lastName(fullName = '') {
      if (!fullName) return '';
      const arr = fullName.split('/');
      return arr[arr.length - 1];
    }
  },
  data() {
    return {
      dialogVisible: false,
      tableHeaderSign: Object.freeze(studentSignTable),
      searchFormData: {
        contact_id: ''
      },
      getTableData: contact.getStudentSignUpDetail,
      baseInfo: {}
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.searchFormData.contact_id = this.contact_id;
        contact
          .getStudentDetail({
            params: {
              contact_id: this.contact_id
            }
          })
          .then(res => {
            if (res && res.data) this.baseInfo = res.data.contact_info;
          });
        this.search();
      });
    },
    search() {
      this.$refs.lyTable.setData();
    },
    submit() {}
  }
};
</script>
<style lang="less">
.student-info {
  .base-inf {
    list-style: none;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
}
</style>
